import { Text } from '@/components/Text';
import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  count?: number;
  actions?: ReactNode;
  filters?: ReactNode;
}

export const PageHeader = ({
  title,
  count,
  actions,
  filters,
}: PageHeaderProps) => {
  return (
    <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex w-full items-center justify-between gap-2 md:w-fit md:gap-4">
        <div className="flex flex-row items-center justify-center gap-2">
          <h1 className="text-lg font-semibold text-secondary">{title}</h1>
          {count !== undefined && (
            <Text className="text-sm font-light text-gray-light">
              ({count})
            </Text>
          )}
        </div>
        {actions}
      </div>
      {filters && (
        <div className="flex w-full flex-col gap-4 md:flex-row md:items-center md:justify-end">
          {filters}
        </div>
      )}
    </div>
  );
};
